import { render } from "./LoadingScreen.vue?vue&type=template&id=4184204b&scoped=true"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=4184204b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4184204b"]])

export default __exports__